"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EnvironmentTypes = void 0;
require("core-js/modules/es.string.starts-with.js");
var EnvironmentTypes = exports.EnvironmentTypes = /*#__PURE__*/function (EnvironmentTypes) {
  EnvironmentTypes["DEVELOPMENT"] = "development";
  EnvironmentTypes["STAGING"] = "staging";
  EnvironmentTypes["PRODUCTION"] = "production";
  return EnvironmentTypes;
}({});
/**
 * Fallback to get the environment based on the hostname
 *
 * @returns {Environment} - The environment based on the hostname
 */
var getEnvironmentByHostname = function getEnvironmentByHostname() {
  var _window$location;
  var hostname = typeof window !== 'undefined' ? ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || '' : '';
  hostname = hostname.toLowerCase();
  if (hostname.startsWith('dev') || hostname === 'localhost') {
    return EnvironmentTypes.DEVELOPMENT;
  }
  if (hostname.startsWith('qa')) {
    return EnvironmentTypes.STAGING;
  }
  return EnvironmentTypes.PRODUCTION;
};

/**
 * Gets the environment based on the zola environment or hostname
 *
 * @memberof client
 *
 * @returns {EnvironmentTypes} - The environment
 */
var _default = exports.default = function _default() {
  var _window$zola;
  var zolaEnv = typeof window !== 'undefined' ? (_window$zola = window.zola) === null || _window$zola === void 0 ? void 0 : _window$zola.env : process.env.ZOLA_ENV || process.env.NODE_ENV;
  if (!zolaEnv) {
    zolaEnv = getEnvironmentByHostname();
  }
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return EnvironmentTypes.DEVELOPMENT;
    case 'staging':
    case 'stage':
      return EnvironmentTypes.STAGING;
    case 'production':
    case 'prod':
      return EnvironmentTypes.PRODUCTION;
    default:
      return EnvironmentTypes.PRODUCTION;
  }
};